import React from 'react';

export default function ModalMultiWrapper({
  modals = {},
  isOpen = false,
  toggle,
  selectedModal = null,
}) {
  if (!modals[selectedModal]) {
    return null;
  }

  // Retrieve the component for the selected modal
  const ActiveModal = modals[selectedModal].component;
  const modalProps = modals[selectedModal].props || {};

  return (
    <div>
      <ActiveModal isOpen={isOpen} toggle={toggle} {...modalProps} />
    </div>
  );
}
